import { render, staticRenderFns } from "./ClientTeamsTabComponent.vue?vue&type=template&id=7f092c3c&scoped=true&"
import script from "./ClientTeamsTabComponent.vue?vue&type=script&lang=ts&"
export * from "./ClientTeamsTabComponent.vue?vue&type=script&lang=ts&"
import style0 from "./ClientTeamsTabComponent.vue?vue&type=style&index=0&id=7f092c3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f092c3c",
  null
  
)

export default component.exports